import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { loadGA4AfterConsent, trackPageView } from "../../analytics/ga4";

const GA_ID = process.env.REACT_APP_GA_ID;

export const ConsentBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!GA_ID) return;
    const c = localStorage.getItem("rc-consent");
    if (c === "accept") {
      loadGA4AfterConsent().then((loaded) => {
        if (loaded) trackPageView(window.location);
      });
    } else if (!c) setShow(true);
  }, []);

  const choose = (accepted) => {
    localStorage.setItem("rc-consent", accepted ? "accept" : "decline");
    if (accepted) {
      loadGA4AfterConsent().then((loaded) => {
        if (loaded) trackPageView(window.location);
      });
    }
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] border-t border-nuit/10 bg-white/95 backdrop-blur-md" data-testid="consent-banner">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 px-5 py-4 lg:px-10">
        <p className="max-w-2xl text-xs leading-relaxed text-nuit/70">
          Avec votre accord, nous utilisons Google Analytics pour mesurer la fréquentation du site
          et améliorer nos services. Voir la{" "}
          <Link to="/politique-confidentialite" className="font-semibold text-petrole underline">politique de confidentialité</Link>.
        </p>
        <div className="flex gap-3">
          <button onClick={() => choose(false)} data-testid="consent-decline" className="rounded-full border border-nuit/20 px-5 py-2.5 text-xs font-bold uppercase tracking-[0.12em] text-nuit transition-colors duration-300 hover:bg-nuit/5">
            Refuser
          </button>
          <button onClick={() => choose(true)} data-testid="consent-accept" className="rounded-full bg-nuit px-5 py-2.5 text-xs font-bold uppercase tracking-[0.12em] text-white transition-colors duration-300 hover:bg-petrole">
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
};
